import { useAuthStore } from "@/store/auth/auth.store";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { userQueryKeys } from "./user.api";
import { useTenantStore } from "@/store/tenant/tenant.store";

/**
 * Logout mutation
 * @returns Logout mutation
 */
export const useLogout = () => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            useAuthStore.getState().expireToken();
            return auth.signoutRedirect();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [userQueryKeys.userData] });
            useTenantStore.getState().clearTenantData();
        },
    });
};
